// Get references to the relevant elements
const scrollableDiv = document.querySelector( '.logo-list__slider' );
const prevButton = document.querySelector( '.logo-arrow-left' );
const nextButton = document.querySelector( '.logo-arrow-right' );

// Define the scroll amount when clicking the buttons
const scrollAmount = 300;

// Function to update button visibility
function updateButtonVisibility()
{
    const isAtLeftEdge = scrollableDiv.scrollLeft === 0;
    const isAtRightEdge = scrollableDiv.scrollLeft + scrollableDiv.clientWidth === scrollableDiv.scrollWidth;

    if (isAtLeftEdge)
    {
        prevButton.style.display = 'none';
    }
    else
    {
        prevButton.style.display = 'block';
    }

    if (isAtRightEdge)
    {
        nextButton.style.display = 'none';
    }
    else
    {
        nextButton.style.display = 'block';
    }
}

// Add a click event listener to the "Next" button
nextButton.addEventListener( 'click', () =>
{
    scrollableDiv.scrollBy(
    {
        left: scrollAmount,
        behavior: 'smooth',
    });
    updateButtonVisibility();
});

// Add a click event listener to the "Previous" button
prevButton.addEventListener( 'click' , () =>
{
    scrollableDiv.scrollBy(
    {
        left: -scrollAmount,
        behavior: 'smooth',
    });
    updateButtonVisibility();
});

// Add a scroll event listener to update button visibility when scrolling
scrollableDiv.addEventListener( 'scroll' , updateButtonVisibility);

// Initialize button visibility
setTimeout(() =>
{
    updateButtonVisibility();
}, 1000);